import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/marketing/marketingQueryKeys.ts
var t = e("marketing", { active: (e) => ["active", e] });
//#endregion
export { t as marketingQueryKeys };
